/**
 * Created by sunshine on 2016/12/14.
 */
import Vue from 'vue'
import VueResource from 'vue-resource'
import manual from './manual.vue'
// Resource
Vue.use(VueResource)
new Vue({
  el: '#app',
  template: '<manual/>',
  components: {manual}
})



// WEBPACK FOOTER //
// ./src/pages/manual/index.js